module.exports = "https://cdn.hellotech.com/client-assets/xfinity-topnav-logo_0c7713c0d4cef1ccb591b95b4bfd9d93.svg";